"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCalcFieldJoin = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var IkeCalcFieldJoin = /** @class */ (function () {
    function IkeCalcFieldJoin(field) {
        this.field = field;
        this.wire = field.parent;
        var form = this.wire.schema.getForm();
        var parentSubFormInstance = this.wire.parent.parent;
        if (form.metadata.import.version >= core_shared_1.IkeCalcVersion.V0_3_0) {
            this.circuit = this.wire;
            this.span = parentSubFormInstance;
        }
        else {
            // IkeCalc V0.2.x
            this.circuit = parentSubFormInstance;
            this.span = this.circuit.parent.parent;
        }
        this.subformInstanceID = this.wire.instanceId;
    }
    IkeCalcFieldJoin.prototype.getTitle = function () {
        return "".concat(this.span.title, " (").concat(this.span.formTitle, ")");
    };
    IkeCalcFieldJoin.prototype.getFieldValue = function (subform, fieldId) {
        if (subform == null || !subform.hasField(fieldId)) {
            return null;
        }
        var field = subform.getField(fieldId);
        if (!field.hasValue()) {
            return null;
        }
        return field.displayValue;
    };
    IkeCalcFieldJoin.prototype.fieldsEqual = function (subformA, subformB, fieldID) {
        var fieldAValue = this.getFieldValue(subformA, fieldID);
        var fieldBValue = this.getFieldValue(subformB, fieldID);
        return fieldAValue != null && fieldBValue != null && fieldAValue === fieldBValue;
    };
    IkeCalcFieldJoin.prototype.spansOpposing = function (spanA, spanB) {
        if (spanA.instanceId === spanB.instanceId) {
            return false;
        }
        if (!spanA.hasField('spanType') || !spanB.hasField('spanType')) {
            return false;
        }
        var spanAType = spanA.getField('spanType').value;
        var spanBType = spanB.getField('spanType').value;
        if (spanAType == null || spanBType == null) {
            return false;
        }
        if (spanAType === 'NEXT_POLE') {
            return spanBType === 'PREVIOUS_POLE';
        }
        if (spanAType === 'PREVIOUS_POLE') {
            return spanBType === 'NEXT_POLE';
        }
        return spanAType === spanBType;
    };
    IkeCalcFieldJoin.prototype.isDeadend = function (value) {
        return value != null && value.match(/dead[-_ ]*end/i) != null;
    };
    return IkeCalcFieldJoin;
}());
exports.IkeCalcFieldJoin = IkeCalcFieldJoin;
//# sourceMappingURL=field.join.ikecalc.js.map